import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  height: 48px;
  color: #89b11a;
  font-size: 26px;
  line-height: 48px;
  text-align: center;
  vertical-align: top;
  padding: 25px 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Icon = styled.i`
  font-size: 40px;
  line-height: 46px;
  vertical-align: top;
`;

export const TestimonialDone = () => (
  <Wrapper>
    <Icon className="lt-icon-ok" />
    Ваш отзыв получен и ожидает модерации
  </Wrapper>
);
